import { useState } from "react";
import { Accordion, Form, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const timeoutMs = 200;
let typingTimeout;

// don't toggle accordion when clicking on inputs
const onClick = e => e.stopPropagation();
const newTerm = () => ({title: "", content: ""});
const getIdx = target => Number(target.parentElement.parentElement.parentElement.parentElement.dataset.idx);

export function ContractGroup4( { state, dispatch }) {
  const { t } = useTranslation();

  const disabled = state.status === "COMPLETE";

  const [activeKeys, setActiveKeys] = useState([]);

  const [terms, setTerms] = useState(() => {
    const initialTerms = [...state.terms];
    if (!disabled) initialTerms.push(newTerm());
    setActiveKeys([...Array(initialTerms.length).keys()]); // [0, 1, 2, ...]
    return initialTerms;
  });

  const modifyState = () => dispatch({type:"terms", payload: terms});

  const titleChange = ({ target }) => {
    clearTimeout(typingTimeout);
    const idx = getIdx(target);
    setTerms(currentTerms => {
      const newTerms = [...currentTerms];
      newTerms[idx].title = target.value;
      // insert a new term when the last title is modified
      if (idx === newTerms.length - 1 && target.value.trim().length > 0) {
        newTerms.push(newTerm());
        setActiveKeys([...activeKeys, idx]);
      }
      typingTimeout = setTimeout(modifyState, timeoutMs);
      return newTerms;
    });
  };

  const contentChange = ({ target }) => {
    clearTimeout(typingTimeout);
    const idx = getIdx(target);
    setTerms(currentTerms => {
      const newTerms = [...currentTerms];
      newTerms[idx].content = target.value;
      typingTimeout = setTimeout(modifyState, timeoutMs);
      return newTerms;
    });
  };

  const accordionClick = ({ target }) => {
    const idx = Number(target.parentElement.parentElement.dataset.idx);
    if (target.className === "accordion-button") {
      setActiveKeys(activeKeys.filter(key => key !== idx));
    }
    else if (target.className === "accordion-button collapsed") {
      setActiveKeys([...activeKeys, idx]);
    }
  };

  return (
    <Accordion activeKey={activeKeys} alwaysOpen onClick={accordionClick}> {
      terms.map((term, idx) =>
        <Accordion.Item key={idx} eventKey={idx} data-idx={idx}>
          <Accordion.Header>
            <Form.Group as={Col} controlId={`termTitle${idx}`} className="me-5">
              <Form.Label>{t("Term", "Ehto") + ` ${idx + 1}. ` + t("title", "otsikko")}</Form.Label>
              <Form.Control onClick={onClick} className="me-5" disabled={disabled} value={term.title ?? ""} onChange={titleChange} />
            </Form.Group>
          </Accordion.Header>
          <Accordion.Body>
            <Form.Group as={Col} controlId={`termContent${idx}`}>
              <Form.Label>{t("Term", "Ehto") + ` ${idx + 1}. ` + t("content", "sisältö")}</Form.Label>
              <Form.Control as="textarea" rows={3} disabled={disabled} value={term.content ?? ""} onChange={contentChange} />
            </Form.Group>
          </Accordion.Body>
        </Accordion.Item>
      )
    }
    </Accordion>
  );

}
